
/*

 Dependancies: _goooglemaps.scss, json-settings/googlemaps/*.json

 <div class="googlemap">
 <div class="googlemap__inner">
 <div class="googlemap__map js-googlemap"
 data-marker-url="<?php bloginfo('template_directory'); ?>/build/img/map-marker.png"
 data-map-settings="<?php bloginfo('template_directory'); ?>/json-settings/googlemaps/googlemaps-1.json">
 </div>
 </div>
 </div>


 You can add multiple maps by creating more map.json files, and linking to them
 via the data-map-settings data-attribute on the maps HTML.

 You can add multiple markers to any map by appending to the locations array within
 the maps corresponding map.json file.

 */

WW.googlemaps = function($) {
    'use strict';

    const createMap = (googlemap) => {
        const json = JSON.parse(googlemap.getAttribute('data-map-settings'));

        let map;

        const initialize = mapConfig => {

            const latLang = new google.maps.LatLng(mapConfig.mapParams.latitude,
                mapConfig.mapParams.longitude),
                MY_MAPTYPE_ID = 'custom_style';
            let featureOpts,
                mapOptions,
                styledMapOptions,
                customMapType;

            mapOptions = {
                center: latLang,
                zoom: parseInt(mapConfig.mapParams.zoom),
                draggable: true,
                scrollwheel: false,
                panControl: false,
                mapTypeControl: false,
                zoomControl: true,
                streetViewControl: false,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
                },
                mapTypeId: MY_MAPTYPE_ID
            };

            featureOpts = [
                //{elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                {elementType: 'labels.text.stroke', stylers: [{color: '#919191'}]},
                {elementType: 'labels.text.fill', stylers: [{color: '#000000'}]},
                {
                    featureType: 'administrative.locality',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#000000'}]
                },
                {
                    'featureType': 'landscape',
                    'elementType': 'geometry.fill',
                    'stylers': [
                        {
                            'color': '#bdffb3'
                        },
                        {
                            'visibility': 'on'
                        }
                    ]
                },
                {
                    'featureType': 'landscape.man_made',
                    'elementType': 'geometry.fill',
                    'stylers': [
                        {
                            'color': '#ffffc5'
                        }
                    ]
                },
                {
                    'featureType': 'landscape.man_made',
                    'elementType': 'geometry.stroke',
                    'stylers': [
                        {
                            'color': '#6f7bb9'
                        },
                        {
                            'visibility': 'on'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#000000'}]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [{color: '#6cd147'}]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#6b9a76'}]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [{color: '#ffffff'}]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.stroke',
                    stylers: [{color: '#dddca6'}, {'visibility': 'on'}, {'weight' : 2}]
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#000000'}]
                },
                {
                    'featureType': 'road.highway',
                    'elementType': 'labels.text.stroke',
                    'stylers': [{'visibility': 'on'}, {color: '#ffffff'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [{color: '#f5f444'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [{color: '#f1b243'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels.text.fill',
                    stylers: [{color: '#000000'}]
                },
                {
                    'featureType': 'road.highway',
                    'elementType': 'labels.text.stroke',
                    'stylers': [{'visibility': 'on'}, {color: '#ffff4d'}]
                },
                {
                    featureType: 'transit',
                    elementType: 'geometry',
                    stylers: [{color: '#444444'}]
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        { hue: '#61b5f2' },
                        { saturation: 72 },
                        { lightness: -13 },
                        { visibility: 'on' }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'labels',
                    stylers: [
                        { hue: '#252c24' },
                        { saturation: -78 },
                        { lightness: -79 },
                        { visibility: 'on' }
                    ]
                }
            ];

            styledMapOptions = {
                name: 'Custom Style'
            };

            customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);
            map = new google.maps.Map(googlemap,mapOptions);
            map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

            mapConfig.locations.forEach(createMarker);
        };

        const createMarker = location => {
            let infowindow = new google.maps.InfoWindow(),
                longitude = parseFloat(location.longitude),
                latitude = parseFloat(location.latitude),
                imageLocation = googlemap.getAttribute('data-marker-url'),
                image,
                marker;

            image = new google.maps.MarkerImage(imageLocation,
                // This marker is 21 pixels wide by 30 pixels tall.
                new google.maps.Size(40, 48),
                // The origin for this image is 0,0.
                new google.maps.Point(0,0),
                // The anchor for this image is the base of the flagpole at 18,42.
                new google.maps.Point(10, 30)
            );

            marker = new google.maps.Marker({
                map: map,
                position: {
                    lat: latitude,
                    lng: longitude
                },
                visible: true,
                icon: image // This path is the custom pin to be shown. Remove this line and the proceeding comma to use default pin
            });

            infowindow.setContent(`
                <div class="info-window-hook">
                    <div class="u-txt-bold u-txt-md u-txt-univiabold">
                        ${location.headline}
                    </div>
                    <div>
                        ${location.bodyText}
                    </div>
                </div>
            `);

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, this);
            });
        };
        initialize(json.map);
    };

    const maps = document.querySelectorAll('.js-googlemap');
    [].forEach.call(maps, map => {
        createMap(map);
    });

    return this;
};

// add .googlemaps($) to main.js
